import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import QuerschnittVerpresskoerper from "./QuerschnittVerpresskoerper";
import TeilsicherheitsbeiwertZement from "./TeilsicherheitsbeiwertZement";
import Verpresskoerperdurchmesser from "./Verpresskoerperdurchmesser";
import Zylinderdruckfestigkeit from "./Zylinderdruckfestigkeit";

function ParameterVerpresskoerper({ expand, Ac, fck }) {
  const { t } = useTranslation("translation");

  const hide = `${expand ? "box" : "d-sm-none"} `;

  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("inner.buckling.ofner.parameterGroutingBody.headline")}</h1>
        </div>
      </div>
      <div className="row">
        <AnimatedCol>
          <Verpresskoerperdurchmesser />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <QuerschnittVerpresskoerper querschnittVerpresskoerper={Ac} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Zylinderdruckfestigkeit zylinderdruckfestigkeit={fck} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <TeilsicherheitsbeiwertZement />
        </AnimatedCol>
      </div>
    </div>
  );
}

export default ParameterVerpresskoerper;
